export enum GraphType {
    STATION_AVAILABILITY = 'STATION_AVAILABILITY',
    STATION_ALARM = 'STATION_ALARM',
    DEFAULT = 'DEFAULT'
}
